<template>
  <div>
    <input v-model="playerName" placeholder="Your name for High Score" @keypress.enter="saveScore" type="text">
    <MyButton :btnIcon="'save'" @click.native="saveScore"></MyButton>
  </div>
</template>

<script>
import MyButton from "@/components/MyButton";

export default {
name: "MyInput",
  props:['userScore', 'scoreSaved'],
  components:{
    MyButton: MyButton
  },
  data(){
    return{
      playerName:''
    }
  },
  methods:{
    saveScore(){
      let localScore = JSON.parse(localStorage.getItem('User Score')) !== null ?
          JSON.parse(localStorage.getItem('User Score')):
          []

      if(localScore.length < 3){
        localScore.unshift({name: this.playerName, score: this.userScore})
      } else {
        for(let i = 0; i < localScore.length;i++){
          if(this.userScore > localScore[i].score){
            localScore.splice(i,0, {name: this.playerName, score: this.userScore})
            localScore.pop()
            break
          }
        }
      }


      localStorage.setItem('User Score', JSON.stringify(localScore))
      this.scoreSaved()
    }
  }
}
</script>

<style scoped>
  div{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  input{
    width: 300px;
    height: 50px;
    background-color: var(--bg);
    outline: none;
    color: var(--color);
    padding: 10px 20px;
    border: none;
    border-radius: 35px;
    box-shadow: var(--insets);
  }
</style>